// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__MuB9F","header":"ReportDetails_header__EEe5g","title":"ReportDetails_title__2VDT-","left":"ReportDetails_left__VYnTo"};